// Enrollment completion and verification are recovered from the cookie-bound BFF draft.
// No OTP, grant, canonical token or customer master is stored in browser storage.
export const emptyForm = { name: '', phone: '', shop_name: '', location: '', consent: false };